<template>
  <div class="container-fluid full-height">
    <img src="../assets/logo.png" alt="nextlead.io" class="center"/>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .full-height {
    height: 100vh;
    margin: 0;
    padding: 0;
    background-color: #edf5f7;
    background-position: center;
    background-repeat: no-repeat;
    background-image:url(../assets/bg.jpg);
    display: flex;
    align-items: center;
    justify-content: center
  }
  .center {
    display: block;
    height: 60px;
  }
</style>
